<script>
import { mapGetters } from '../store'

export default {
    name: 'SettingsGeneral',
    components: {},
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            loading: false,
            formState: {}
        }
    },
    methods: {
        async onSubmit() {
            if(this.formState.$valid) {
                try {
                    await this.userResource.save()
                    this.addSuccess('Settings have been updated')
                } catch(e) {
                    this.parseAPIErrorsOrRethrow(e)
                }
            }
        }
    },
    async mounted() {
        
    },
}
</script>

<template>
    <div v-page-title="'Settings'">
        <b-row>
            <b-col class="section-heading">
                <h4>General Settings</h4>
                <hr />
            </b-col>
        </b-row>

        <b-row v-if="userResource">
            <b-col md="6">
                <messages />

                <vue-form :state="formState" @submit.prevent="onSubmit">

                    <validate auto-label>
                        <b-form-group label="Email Address" description="This is also your username">
                            <b-form-input type="email" v-model="userResource.attributes.username" @input="(value) => userResource.attributes.email = value" name="email" required />
                            <field-messages name="email" show="$submitted">
                                <small slot="required" class="text-danger">Required</small>
                                <small slot="email" class="text-danger">Email is not valid</small>
                            </field-messages>
                        </b-form-group>
                    </validate>

                    <validate auto-label>
                        <b-form-group label="First Name">
                            <b-form-input v-model="userResource.attributes.first_name" name="firstName" required />
                            <field-messages name="firstName" show="$submitted">
                                <small slot="required" class="text-danger">Required</small>
                            </field-messages>
                        </b-form-group>
                    </validate>

                    <validate auto-label>
                        <b-form-group label="Last Name">
                            <b-form-input v-model="userResource.attributes.last_name" name="lastName" required />
                            <field-messages name="lastName" show="$submitted">
                                <small slot="required" class="text-danger">Required</small>
                            </field-messages>
                        </b-form-group>
                    </validate>

                    <b-button type="submit" variant="primary">Submit</b-button>

                </vue-form>
            </b-col>
        </b-row>

        <div v-else>
            Loading...
        </div>
    </div>
</template>

<style lang="scss"></style>
